module.exports = __webpack_public_path__ + "img/v1-library-mobile.37c86353.png";